<!-- <div class="settings-container fit-content">
  <h2 class="settings-title">Settings</h2>
  <div class="settings-tabs">
    <button [class.active]="activeTab === 'branding'" (click)="setTab('branding')">Branding</button>
    <button [class.active]="activeTab === 'custom'" (click)="setTab('custom')">Custom Settings</button>
    <button [class.active]="activeTab === 'password'" (click)="setTab('password')">Change Password</button>
  </div>
  <div class="settings-content">
    <ng-container *ngIf="activeTab === 'branding'">

      <div class="settings-card branding-card">
        <h3>Branding</h3>
        <p>Customize your organization's logo, colors, and appearance.</p>
        <div class="branding-logo-section">
          <div class="logo-preview">
            <img [src]="organizationLogoUrl || 'assets/default-logo.png'" alt="Organization Logo" class="org-logo-img"/>
            <span *ngIf="!organizationLogoUrl" class="logo-placeholder">No logo uploaded</span>
          </div>
          <div class="logo-upload">
            <label for="logoUpload" class="upload-label">Upload Logo</label>
            <input type="file" id="logoUpload" (change)="onLogoUpload($event)" accept="image/*"/>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'custom'">

      <div class="settings-card">
        <h3>Custom Settings</h3>
        <p>Configure custom options for your organization.</p>

      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'password'">

      <div class="settings-card password-card">
        <h3>Change Password</h3>
        <form (ngSubmit)="onChangePassword()"  class="change-password-form">
          <div class="form-group">
            <label for="currentPassword">Current Password</label>
            <input type="password" id="currentPassword" name="currentPassword" required/>
          </div>
          <div class="form-group">
            <label for="newPassword">New Password</label>
            <input type="password" id="newPassword" name="newPassword" required/>
          </div>
          <div class="form-group">
            <label for="confirmPassword">Confirm New Password</label>
            <input type="password" id="confirmPassword" name="confirmPassword" required/>
          </div>
          <button type="submit" class="btn-save" >Save</button>
        </form>
      </div>
    </ng-container>
  </div>
</div> -->

<div class="tab-container">
  <div class="tab-header">
    <!-- <button class="tab-button" [class.active]="activeTab === 'branding'" (click)="setTab('branding')">
      Branding
    </button> -->


      <button *ngIf="canAccessAlertSettings" class="tab-button" [class.active]="activeTab === 'custom'"
              (click)="setTab('custom')">
      Alert & Notification Settings
    </button>

    <button class="tab-button" [class.active]="activeTab === 'password'" (click)="setTab('password')">
      Custom Settings
    </button>

  </div>
  <div class="settings-content">
    <ng-container *ngIf="activeTab === 'branding'">

      <div class="settings-card branding-card">
        <h3>Branding</h3>
        <p>Customize your organization's logo, colors, and appearance.</p>
        <div class="branding-logo-section">
          <div class="logo-preview">
            <img [src]="organizationLogoUrl || 'logo/kyra-logo-no-bg.png'" alt="Organization Logo"
              class="org-logo-img" />
            <span *ngIf="!organizationLogoUrl" class="logo-placeholder">No logo uploaded</span>
          </div>
          <div class="logo-upload">
            <label for="logoUpload" class="upload-label">Upload Logo</label>
            <input type="file" id="logoUpload" (change)="onLogoUpload($event)" accept="image/*" />
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Notifications tab: updated design -->
      <ng-container *ngIf="canAccessAlertSettings && activeTab === 'custom'">
      <div class="settings-card notifications-card">
          <div class="notifications-header preferences-card-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2m6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5z" />
          </svg>
          
          <div class="notifications-title">
            <h3>Notification Channel</h3>
              <p class="preferences-subtitle">Organization-wide channels for normal alerts. Does not control mobile
                  verification OTP.</p>
          </div>
              <button
                      type="button"
                      class="btn-save-alerts preferences-save-btn"
                      *ngIf="isAdmin"
                      (click)="saveNotificationChannels()"
                      [disabled]="savingNotificationChannels">
                  {{ savingNotificationChannels ? 'Saving...' : 'Save' }}
              </button>

        </div>
        <!-- <div class="notifications-subtitle">
          <p>Configure how customers receive status updates</p>
        </div> -->

        <div class="notification-list">
          <div class="notification-row"
               *ngFor="let n of notifications"
               [class.notification-row-readonly]="n.comingSoon"
               [attr.title]="n.comingSoon ? 'SMS notifications will be available in a future release.' : null">
            <div class="left">
              <div class="icon-wrap">
                <ng-container [ngSwitch]="n.id">
                  <!-- WhatsApp -->
                  <svg *ngSwitchCase="'whatsapp'" class="notif-icon" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24" width="20" height="20">
                    <path fill="currentColor"
                      d="M20.52 3.48A11.88 11.88 0 0012 0C5.37 0 0 5.37 0 12a11.87 11.87 0 001.86 6.23L0 24l5.91-1.55A11.94 11.94 0 0012 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.2-3.48-8.52zM12 21.5c-1.5 0-2.98-.38-4.28-1.1l-.3-.18-3.51.92.94-3.43-.2-.34A9.5 9.5 0 012.5 12c0-5.25 4.25-9.5 9.5-9.5s9.5 4.25 9.5 9.5S17.25 21.5 12 21.5zM16 14.2c-.28-.14-1.66-.82-1.92-.92-.26-.1-.45-.14-.64.14-.18.28-.7.92-.86 1.1-.16.18-.32.2-.6.07-.28-.14-1.18-.43-2.24-1.37-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.43.12-.57.12-.12.28-.32.42-.48.14-.16.18-.28.28-.46.1-.18.04-.34-.02-.48-.07-.14-.64-1.54-.88-2.13-.23-.56-.47-.48-.64-.49l-.55-.01c-.18 0-.48.07-.73.34-.25.27-.98.96-.98 2.34 0 1.38 1.01 2.72 1.15 2.9.14.18 1.98 3.12 4.8 4.26 3.3 1.3 3.3.87 3.9.82.6-.05 1.95-.8 2.23-1.57.28-.77.28-1.43.2-1.57-.07-.14-.26-.18-.54-.32z" />
                  </svg>
                  <!-- SMS phone icon -->
                  <svg *ngSwitchCase="'sms'" class="notif-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    width="20" height="20">
                    <path fill="currentColor"
                      d="M20 2H4a2 2 0 00-2 2v16l4-4h14a2 2 0 002-2V4a2 2 0 00-2-2zM7 9h10v2H7V9z" />
                  </svg>
                  <!-- Email -->
                  <svg *ngSwitchCase="'email'" class="notif-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    width="20" height="20">
                    <path fill="currentColor"
                      d="M20 4H4c-1.1 0-2 .9-2 2v12a1 1 0 001.6.8L7 16h13a2 2 0 002-2V6c0-1.1-.9-2-2-2zM4 6h16l-8 5L4 6z" />
                  </svg>
                </ng-container>
              </div>
              <div class="label">{{ n.label }}</div>
            </div>

            <div class="right">
              <label class="toggle-switch" [class.toggle-switch-readonly]="n.comingSoon">
                <input type="checkbox"
                       [checked]="n.enabled"
                       (change)="toggleNotification(n.id)"
                       [disabled]="!isAdmin || n.comingSoon"/>
                <span class="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

          <div class="settings-card notification-preferences-card" *ngIf="isAdmin">
              <div class="preferences-card-header">
                  <div class="notifications-title">
                      <h3>User Notification Preferences</h3>
                      <p class="preferences-subtitle">Configure notification channels and monitoring preferences for
                          organization users.</p>
                  </div>
                  <button
                          type="button"
                          class="btn-save-alerts preferences-save-btn"
                          (click)="saveNotificationPreferences()"
                          [disabled]="savingNotificationPreferences || loadingNotificationPreferences">
                      {{ savingNotificationPreferences ? 'Saving...' : 'Save' }}
                  </button>
              </div>

              <p *ngIf="loadingNotificationPreferences" class="preferences-status">Loading preferences...</p>

              <div class="preference-table-wrap"
                   *ngIf="!loadingNotificationPreferences && userNotificationPreferences.length">
                  <div class="preference-matrix">
                      <div class="preference-row preference-header">
                          <div class="preference-col-user">User</div>
                          <div class="preference-col-role">Role</div>
                          <div class="preference-col-toggle">Enabled</div>
                          <div class="preference-col-toggle">Email</div>
                          <div class="preference-col-toggle">WhatsApp</div>
                          <div class="preference-col-monitoring">Monitoring Types</div>
                          <div class="preference-col-action"></div>
                      </div>

                      <ng-container *ngFor="let row of userNotificationPreferences">
                          <div class="preference-row preference-data-row"
                               [class.preference-row-expanded]="isPreferenceRowExpanded(row)">
                              <div class="preference-col-user preference-user">
                                  <strong>{{ getUserDisplayName(row) }}</strong>
                                  <small>{{ row.email }}</small>
                                  <small *ngIf="!row.is_eligible" class="ineligible-note">Not eligible (inactive or
                                      mobile not verified)</small>
                              </div>
                              <div class="preference-col-role">
                                  <span class="superuser-badge">{{ getRoleLabel(row) }}</span>
                              </div>
                              <div class="preference-col-toggle preference-toggle-cell">
                                  <label class="toggle-switch">
                                      <input type="checkbox" [checked]="row.is_enabled"
                                             (change)="toggleUserPreferenceEnabled(row)" [disabled]="!isAdmin"/>
                                      <span class="slider"></span>
                                  </label>
                              </div>
                              <div class="preference-col-toggle preference-toggle-cell">
                                  <label class="toggle-switch"
                                         [class.toggle-switch-readonly]="isUserPreferenceChannelControlDisabled(row, 'email')"
                                         [attr.title]="organizationChannelsKnown && !organizationEmailChannelEnabled
                                           ? 'Organization email notifications are disabled.'
                                           : null">
                                      <input type="checkbox"
                                             data-testid="preference-channel-email"
                                             [checked]="row.channels.email"
                                             (change)="toggleUserChannel(row, 'email')"
                                             [disabled]="isUserPreferenceChannelControlDisabled(row, 'email')"/>
                                      <span class="slider"></span>
                                  </label>
                              </div>
                              <div class="preference-col-toggle preference-toggle-cell">
                                  <label class="toggle-switch"
                                         [class.toggle-switch-readonly]="isUserPreferenceChannelControlDisabled(row, 'whatsapp')"
                                         [attr.title]="organizationChannelsKnown && !organizationWhatsappChannelEnabled
                                           ? 'Organization WhatsApp notifications are disabled.'
                                           : null">
                                      <input type="checkbox"
                                             data-testid="preference-channel-whatsapp"
                                             [checked]="row.channels.whatsapp"
                                             (change)="toggleUserChannel(row, 'whatsapp')"
                                             [disabled]="isUserPreferenceChannelControlDisabled(row, 'whatsapp')"/>
                                      <span class="slider"></span>
                                  </label>
                              </div>
                              <div class="preference-col-monitoring">
                  <span class="monitoring-summary" [title]="getMonitoringTypesSummary(row)">
                    {{ getMonitoringTypesSummary(row) }}
                  </span>
                              </div>
                              <div class="preference-col-action">
                                  <button
                                          type="button"
                                          class="btn-configure"
                                          [class.btn-configure-active]="isPreferenceRowExpanded(row)"
                                          (click)="togglePreferenceRowExpand(row)"
                                          [attr.aria-expanded]="isPreferenceRowExpanded(row)">
                                      <span>{{ isPreferenceRowExpanded(row) ? 'Collapse' : 'Configure' }}</span>
                                      <span class="configure-caret"
                                            [class.configure-caret-open]="isPreferenceRowExpanded(row)"
                                            aria-hidden="true">&#9662;</span>
                                  </button>
                              </div>
                          </div>

                          <div class="preference-expand-panel" *ngIf="isPreferenceRowExpanded(row)">
                              <div class="monitoring-type-panel">
                                  <label class="monitoring-type-option monitoring-type-option-receive-all">
                                      <input
                                              type="checkbox"
                                              class="monitoring-type-checkbox"
                                              [checked]="row.receive_all_monitoring_types"
                                              (change)="toggleReceiveAllMonitoringTypes(row)"
                                              [disabled]="!isAdmin || !row.is_enabled"/>
                                      <span>Receive All Monitoring Types</span>
                                  </label>
                                  <div
                                          class="monitoring-type-options-grid"
                                          [class.monitoring-type-options-grid-disabled]="row.receive_all_monitoring_types">
                                      <label *ngFor="let option of monitoringTypeOptions"
                                             class="monitoring-type-option">
                                          <input
                                                  type="checkbox"
                                                  class="monitoring-type-checkbox"
                                                  [checked]="isMonitoringTypeSelected(row, option.value)"
                                                  (change)="toggleMonitoringType(row, option.value)"
                                                  [disabled]="isMonitoringTypeSelectionDisabled(row)"/>
                                          <span>{{ option.label }}</span>
                                      </label>
                                  </div>
                              </div>
                          </div>
                      </ng-container>
                  </div>
              </div>
          </div>

          <form [formGroup]="alertDirectionForm" (ngSubmit)="saveAlertDirections()">
        <div class="settings-card alert-direction-card">
          <div class="alert-direction-container">
            <div class="alert-direction-left">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3" />
              </svg>
                <h3>Blocklist Alert Direction</h3>
            </div>
            <div class="alert-direction-right">
              <label class="radio-option">
                <input type="radio" formControlName="blocklistAlertDirection" value="ENTRY"/>
                <span>Entry</span>
              </label>
              <label class="radio-option">
                  <input type="radio" formControlName="blocklistAlertDirection" value="EXIT"/>
                  <span>Exit</span>
              </label>
                <label class="radio-option">
                <input type="radio" formControlName="blocklistAlertDirection" value="ENTRY_EXIT" />
                <span>Entry & Exit</span>
              </label>
            </div>
          </div>
        </div>
        <div class="settings-card alert-direction-card">
          <div class="alert-direction-container">
            <div class="alert-direction-left">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3" />
              </svg>
                <h3>Hotlist Alert Direction</h3>
            </div>
            <div class="alert-direction-right">
              <label class="radio-option">
                <input type="radio" formControlName="hotlistAlertDirection" value="ENTRY"/>
                <span>Entry</span>
              </label>
                <label class="radio-option">
                    <input type="radio" formControlName="hotlistAlertDirection" value="EXIT"/>
                    <span>Exit</span>
              </label>
              <label class="radio-option">
                <input type="radio" formControlName="hotlistAlertDirection" value="ENTRY_EXIT"/>
                <span>Entry & Exit</span>
              </label>
            </div>
          </div>
        </div>
        <div class="settings-card alert-direction-card">
          <div class="alert-direction-container">
            <div class="alert-direction-left">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3" />
              </svg>
                <h3>Vehicle Monitoring Direction</h3>
            </div>
            <div class="alert-direction-right">
              <label class="radio-option">
                <input type="radio" formControlName="vehicleAlertDirection" value="ENTRY"/>
                <span>Entry</span>
              </label>
              <label class="radio-option">
                <input type="radio" formControlName="vehicleAlertDirection" value="EXIT"/>
                <span>Exit</span>
              </label>
              <label class="radio-option">
                <input type="radio" formControlName="vehicleAlertDirection" value="ENTRY_EXIT"/>
                <span>Entry & Exit</span>
              </label>
            </div>
          </div>
        </div>
        <div class="settings-card alert-direction-card">
          <div class="alert-direction-container">
            <div class="alert-direction-left">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3" />
              </svg>
              <h3>RTO / Area Analytics Direction</h3>
            </div>
            <div class="alert-direction-right">
              <label class="radio-option">
                <input type="radio" formControlName="rtoAreaDirection" value="ENTRY"/>
                <span>Entry</span>
              </label>
                <label class="radio-option">
                    <input type="radio" formControlName="rtoAreaDirection" value="EXIT"/>
                    <span>Exit</span>
              </label>
              <label class="radio-option">
                <input type="radio" formControlName="rtoAreaDirection" value="ENTRY_EXIT"/>
                <span>Entry & Exit</span>
              </label>
            </div>
          </div>
        </div>
              <div class="settings-card alert-direction-card" data-testid="settings-parking-capacity">
          <div class="alert-direction-container">
            <div class="alert-direction-left">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 7h16M4 12h16M4 17h16" />
              </svg>
              <h3>Parking Capacity</h3>
            </div>
            <div class="alert-direction-right">
                <input
                        type="number"
                        min="0"
                        formControlName="parkingCapacity"
                        class="capacity-input"
                        data-testid="settings-parking-capacity-input"
                        [attr.readonly]="canEditParkingCapacity ? null : true"
                        [attr.title]="canEditParkingCapacity ? null : (parkingCapacityFeatureEnabled ? 'Read-only for your role' : 'Parking Capacity feature is disabled for this organization')"
                />
            </div>
          </div>
        </div>

        <div *ngIf="isAdmin" class="alert-button-container">
          <button type="submit" class="btn-save-alerts">Save</button>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="activeTab === 'password'">

      <div class="settings-card password-card">
        <h3>Change Password</h3>
        <form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()" class="change-password-form">
          <div class="form-group">
            <label for="currentPassword">Current Password*</label>
            <div class="password-input-wrapper">
              <input 
                [type]="isPasswordVisible ? 'text' : 'password'" 
                id="currentPassword" 
                formControlName="currentPassword" 
                required />
            </div>
            <div  class="error" *ngIf="changePasswordForm.get('currentPassword')?.invalid && changePasswordForm.get('currentPassword')?.touched">
              <small *ngIf="changePasswordForm.get('currentPassword')?.errors?.['required']">Current Password is required</small>
            </div>
          </div>
          <div class="form-group">
            <label for="newPassword">New Password(Min 3 & Max 10 Characters) *</label>
            <div class="password-input-wrapper">
              <input 
                [type]="isPasswordVisible ? 'text' : 'password'" 
                id="newPassword" 
                formControlName="newPassword" 
                required />
            </div>
            <div  class="error" *ngIf="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched">
              <small *ngIf="changePasswordForm.get('newPassword')?.errors?.['required']">New Password is required</small>
            </div>
          </div>
          <div class="form-group">
            <label for="confirmPassword">Confirm New Password(Min 3 & Max 10 Characters) *</label>
            <div class="password-input-wrapper">
              <input 
                [type]="isPasswordVisible ? 'text' : 'password'" 
                id="confirmPassword" 
                formControlName="confirmNewpassword" 
                required />
              <button type="button" class="toggle-visibility" (click)="togglePasswordVisibility()" title="Toggle password visibility">
                <fa-icon *ngIf="isPassword" [icon]="passwordsMatch ? ['fas', 'check']:  ['fas', 'xmark']" [class]="passwordsMatch ? 'match-indicator': 'unmatch-indicator'"></fa-icon>
                <fa-icon [icon]="isPasswordVisible ? ['fas', 'eye-slash'] : ['fas', 'eye']"></fa-icon>

              </button>
              <!-- <div class="validation-icon" *ngIf="isPassword">
                <fa-icon 
                  *ngIf="passwordsMatch" 
                  [icon]="['fas', 'square-check']" 
                  class="icon-match"
                  title="Passwords match"></fa-icon>
                <fa-icon 
                  *ngIf="!passwordsMatch" 
                  [icon]="['fas', 'square-xmark']" 
                  class="icon-mismatch"
                  title="Passwords do not match"></fa-icon>
              </div> -->
            </div>
            
            <div  class="error" *ngIf="changePasswordForm.get('confirmNewpassword')?.invalid && changePasswordForm.get('confirmNewpassword')?.touched">
              <small *ngIf="changePasswordForm.get('confirmNewpassword')?.errors?.['required']">Confirm Password is required</small>
            </div>
            <div class="error" *ngIf="isPassword && !passwordsMatch">
              Passwords do not match
            </div>
          </div>
          <button type="submit" class="btn-save" [disabled]="!changePasswordForm.valid || (isPassword && !passwordsMatch)">Save</button>
        </form>
      </div>
    </ng-container>
  </div>
</div>
